module.exports = __webpack_public_path__ + "static/img/platphom4.55c4e8a5.png";